import { calcNum } from './../../config';
import './index.scss';
interface propsType {
  item?: any;
  index?: number;
  seriesState: number;
}
const SignInOverdue = (props: propsType) => {
  const { item, index, seriesState } = props;
  /**
   * @description: 获取签到模块的背景
   * @param {*}
   * @return {*}
   */
  const getSignBgClass = () => {
    const { dailySigninStatus } = item;
    let str = 'signin__body__item';
    // 最后一个
    if (index === 6) str += ' signin__body__item7';
    // dailySigninStatus 每天签到状态 1漏签2已签3未签
    switch (Number(dailySigninStatus)) {
      case 1: //第七天无漏签的情况
        str += ' signin__body__item_leak';
        break;
      case 2:
        str +=
          index === 6
            ? ' signin__body__item7_sucess'
            : ' signin__body__item_sucess';
        break;
      case 3:
        str +=
          index === 6 ? ' signin__body__item7_no' : ' signin__body__item_no';
        break;
    }
    return str;
  };
  /**
   * @description: 获取签到模块的类名
   * @param {*}
   * @return {*}
   */
  const getSignClass = () => {
    const day: any = {
      1: 'one',
      2: 'twoThree',
      3: 'twoThree',
    };
    const day7: any = {
      1: 'one7',
      2: 'twothree7',
      3: 'twothree7',
    };
    // 最后一个
    let str = 'signin__body__item__bottom';
    const key: any = calcNum(item, 4, seriesState);
    if (index === 6) {
      str += ` ${day7[key]}`;
    } else {
      str += ` ${day[key]}`;
    }
    return str;
  };
  return (
    <div className={getSignBgClass()}>
      <div
        className={`signin__body__item__top ${
          item.currentOr === 1 ? 'current' : ''
        }`}
      >
        {item.currentOr === 1 ? '今日' : item.dailyDate}
      </div>
      <div className={getSignClass()}>
        {calcNum(item, 1, seriesState, false) > 0 && (
          <div className="signin__body__item__bottom__item">
            <img
              src={require(`@/images/signIn/signin_fragment${
                item.dailySigninStatus === 1 ? '_leak' : ''
              }.png`)}
              alt=""
            />
            <p>
              {/* 碎片  只有连签奖品的情况下，如果用户为连签用户，文案红色，非连签用户，文案灰色 */}
              <span
                className={
                  item.fragment <= 0 ? (seriesState === 1 ? 'red' : 'gary') : ''
                }
              >
                碎片
              </span>
              {item.fragment > 0 ? item.fragment : ''}
              {item.fragmentSeries > 0 && (
                <span className={seriesState === 1 ? 'red' : 'gary'}>
                  {/* 有非连签奖品的时候，显示+，否则不显示 */}
                  {item.fragment > 0 ? '+' : ''}
                  {item.fragmentSeries}
                </span>
              )}
            </p>
          </div>
        )}
        {calcNum(item, 2, seriesState, false) > 0 && (
          <div className="signin__body__item__bottom__item">
            <img
              src={require(`@/images/signIn/signin_money${
                item.dailySigninStatus === 1 ? '_leak' : ''
              }.png`)}
              alt=""
            />
            <p>
              {/* 成长值  只有连签奖品的情况下，如果用户为连签用户，文案红色，非连签用户，文案灰色 */}
              <span
                className={
                  item.growth <= 0 ? (seriesState === 1 ? 'red' : 'gary') : ''
                }
              >
                成长值
              </span>
              {item.growth > 0 ? item.growth : ''}
              {item.growthSeries > 0 && (
                <span className={seriesState === 1 ? 'red' : 'gary'}>
                  {/* 有非连签奖品的时候，显示+，否则不显示 */}
                  {item.growth > 0 ? '+' : ''}
                  {item.growthSeries}
                </span>
              )}
            </p>
          </div>
        )}
        {calcNum(item, 3, seriesState, false) > 0 && (
          <div className="signin__body__item__bottom__item">
            <img
              src={require(`@/images/signIn/signin_gift${
                item.dailySigninStatus === 1 ? '_leak' : ''
              }.png`)}
              alt=""
            />
            <p>
              {/* 成长值  只有连签奖品的情况下，如果用户为连签用户，文案红色，非连签用户，文案灰色 */}
              <span
                className={
                  item.dishesSeriesOr === 1
                    ? seriesState === 1
                      ? 'red'
                      : 'gary'
                    : ''
                }
              >
                {item.dishesKey}
              </span>
              {item.dishesSeriesOr === 0 ? (
                <>x{item.dishesCount}</>
              ) : (
                <span className={seriesState === 1 ? 'red' : 'gary'}>
                  x{item.dishesCount}
                </span>
              )}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SignInOverdue;
